import { accountantIbkApi, clientIbkApi } from '@ibk/shared-config';
import { buildValidateOrderSpreadsheetQuery, transformValidateOrderSpreadsheetResponse, } from './validateOrderSpreadsheetQuery';
export const accountantOrderSpreadsheetApi = accountantIbkApi.injectEndpoints({
    endpoints: build => ({
        validateAccountantOrderSpreadsheet: build.mutation({
            query: buildValidateOrderSpreadsheetQuery,
            transformResponse: transformValidateOrderSpreadsheetResponse,
        }),
    }),
    overrideExisting: false,
});
export const clientOrderSpreadsheetApi = clientIbkApi.injectEndpoints({
    endpoints: build => ({
        validateClientOrderSpreadsheet: build.mutation({
            query: buildValidateOrderSpreadsheetQuery,
            transformResponse: transformValidateOrderSpreadsheetResponse,
        }),
    }),
    overrideExisting: false,
});
export const { useValidateAccountantOrderSpreadsheetMutation } = accountantOrderSpreadsheetApi;
export const { useValidateClientOrderSpreadsheetMutation } = clientOrderSpreadsheetApi;
